import { Component } from '@angular/core';
import { MatDivider } from '@angular/material/divider';
import { ChangeLanguage } from "../change-language/change-language";

@Component({
  selector: 'app-logo',
  standalone: true,
  imports: [ChangeLanguage],
  templateUrl: './logo.html',
  styleUrl: './logo.css'
})
export class Logo {


}
